import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { setGetUsersList } from '../../store/thunk/setGetUsersList';
import TableCasino from '../../../../../@casino/ui/table';
import {columns, getRows} from './helpers';
import Title from '../../../../../@casino/ui/title';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0, 
        color: '#fff'
    },
    wrapBlock: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    },
    searchGamer: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    },
    wrapTable: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12,
    }
}))

const SearchUser = () => {
    const [user, setUser] = React.useState('');
    const dispatch = useDispatch();
    const classes = useStyles();
    const search = useSelector(state => state.search_user.list);
    const [desc, setDesc] = React.useState(false);

    const rows = React.useMemo(() => getRows(search), [search]);

    return (
        <div className={classes.root}>
            <Title label="Поиск игроков" />
            <div className={classes.wrapBlock}>
                <label htmlFor="search">
                    <input 
                        type="text" 
                        name="search" 
                        id="search" 
                        value={user} 
                        onChange={(v) => {
                            dispatch(setGetUsersList({
                                page: 1, 
                                rowsPerPage: 10, 
                                search: v.target.value,
                                order: 'id',
                            }));
                            setUser(v.target.value)
                        }} 
                        className={classes.searchGamer}
                        placeholder="Поиск игроков"
                    />
                </label>
            </div>
            <div className={classes.wrapTable}>
                <TableCasino 
                    order={(v) => {
                        dispatch(setGetUsersList({
                            page: 1, 
                            rowsPerPage: 10, 
                            search: user,
                            order: v.id,
                            desc: !desc,
                        }));
                        setDesc(!desc);
                    }}
                    route="/gamer/list/"
                    width={1300}
                    columns={columns}
                    rows={rows}
                />
            </div>
            
        </div>
    )
}

export default SearchUser;